import {
   GET_APPLE_TRANSACTION_DATA_FAILED, GET_APPLE_TRANSACTION_DATA_LOADING,
   GET_APPLE_TRANSACTION_DATA_REMOVE, GET_APPLE_TRANSACTION_DATA_SUCCESS
} from "../types";

const initialState = {
    loading: false,
    error: null,
    data: null,
  };

export const getApplePayTrxReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    
    switch (action.type) {
      case GET_APPLE_TRANSACTION_DATA_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
        };
      case GET_APPLE_TRANSACTION_DATA_SUCCESS:
        return {
          ...state,
          loading: false,
          data: action.payload,
          error: null,
        };
      case GET_APPLE_TRANSACTION_DATA_FAILED:
        return {
          ...state,
          loading: false,
          data: null,
          error: action.error,
        };
      default:
        return state;
    }
  };
  